export default {
  label: "pseudo-heading",
  valueScope:[
    'h1','h2','h3','h4','h5','h6'
  ]
}


// WEBPACK FOOTER //
// ./src/shell/schemas/general/text/pseudo-heading.js